import { ProjectPlanner } from '../../domain/project/projectPlanner/ProjectPlanner';
import { ProjectPlannerDTO } from '../../domain/project/projectPlanner/ProjectPlannerDTO';
import { ProjectPlannerValueField } from '../../domain/project/projectPlanner/ProjectPlannerEntityField';
import {
  ProjectPlannerRepositoryDTO,
  ProjectPlannerValueFieldRepository,
} from '../../domain/project/projectPlanner/ProjectPlannerRepositoryDTO';

export class ProjectPlannerMapper {
  static toDomain(props: ProjectPlannerDTO): ProjectPlanner {
    const { vehicle_fields, stop_fields, task_fields } = props;

    return ProjectPlanner.create({
      vehicle_fields,
      stop_fields,
      task_fields,
    });
  }

  static toRepository(projectDrivers: ProjectPlanner): ProjectPlannerRepositoryDTO {
    const removeType = <T>(field: ProjectPlannerValueField<T>): ProjectPlannerValueFieldRepository => {
      const { type, ...rest } = field;
      return rest;
    };

    const { vehicle_fields, stop_fields, task_fields } = projectDrivers;

    return {
      vehicle_fields: vehicle_fields.map(removeType) as Array<ProjectPlannerValueFieldRepository>,
      stop_fields: stop_fields.map(removeType) as Array<ProjectPlannerValueFieldRepository>,
      task_fields: task_fields.map(removeType) as Array<ProjectPlannerValueFieldRepository>,
    };
  }

  static toDTO(projectDrivers: ProjectPlanner): ProjectPlannerDTO {
    const { vehicle_fields, stop_fields, task_fields } = projectDrivers;

    return {
      vehicle_fields,
      stop_fields,
      task_fields,
    };
  }
}
